module.exports = __webpack_public_path__ + "static/8-964f5cdd36e2674fad553e028094a98f.jpg";